export const inputOnlyNumberTypeString = (value: string) => {
  return value.replace(/[^0-9]/g, '') as '' | `${number}`;
};
